
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    items: {
      type: Array,
      required: false,
      default: (): Array<[]> => []
    }
  }
})
